"use client";

import { useEffect, useState } from "react";
import { supabase } from "@/utils/supabase/client"; // FIXED: Correct path
import { useAuth } from "@/contexts/AuthContext";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle, AlertCircle, Database } from "lucide-react";
import { showSuccess, showError } from "@/utils/toast";

interface TestCase {
  name: string;
  query: () => Promise<any>;
}

const DebugPermissions = () => {
  const { profile } = useAuth();
  const [tests, setTests] = useState<{ name: string; passed: boolean; result?: any }[]>([]);

  const runTests = async () => {
    setTests([]);
    const testCases: TestCase[] = [
      { name: 'Read own profile', query: async () => await supabase.from('profiles').select('*').eq('id', profile?.id).single() },
      { name: 'Read company projects', query: async () => await supabase.from('projects').select('count').eq('company_id', profile?.company_id) },
      { name: 'Read all profiles (should fail for non-admin)', query: async () => await supabase.from('profiles').select('*') },
    ];

    for (const test of testCases) {
      try {
        const { data, error } = await test.query();
        setTests(prev => [...prev, { name: test.name, passed: !error, result: data || error }]);
        if (!error) showSuccess(`${test.name} passed`);
      } catch (error: any) {
        setTests(prev => [...prev, { name: test.name, passed: false, result: error }]);
        showError(`${test.name} failed: ${error.message}`);
      }
    }
  };

  useEffect(() => {
    if (profile) runTests();
  }, [profile]);

  return (
    <div className="container mx-auto p-4">
      <h1 className="text-3xl font-bold mb-6">Debug Permissions (RLS Test)</h1>
      <Card>
        <CardHeader>
          <CardTitle>RLS Policy Tests</CardTitle>
        </CardHeader>
        <CardContent>
          <Button onClick={runTests} variant={tests.length > 0 ? "default" : "outline"}>
            <Database className="mr-2 h-4 w-4" />
            Run Tests
          </Button>
          <div className="space-y-2 mt-4">
            {tests.map((test, i) => (
              <div key={i} className={`flex items-center space-x-2 p-2 rounded ${test.passed ? 'bg-green-50 border-green-200' : 'bg-red-50 border-red-200'}`}>
                <span className={`font-medium ${test.passed ? 'text-green-600' : 'text-red-600'}`}>
                  {test.passed ? <CheckCircle className="h-4 w-4 inline mr-1" /> : <AlertCircle className="h-4 w-4 inline mr-1" />}
                  {test.name}
                </span>
                <pre className="text-xs ml-auto bg-muted p-2 rounded overflow-auto max-w-full">{JSON.stringify(test.result, null, 2)}</pre>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default DebugPermissions;